import { heroMeta, heroCover } from "@/mocks/home";
import Reveal from "./Reveal";

export default function Hero() {
  return (
    <section id="top" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto grid w-full max-w-[1280px] grid-cols-1 items-stretch gap-8 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-12">
        <Reveal className="flex flex-col justify-center">
          <div className="flex items-center gap-3">
            <span className="font-label text-xs tracking-[0.35em] text-primary-600">ISSUE 128</span>
            <span className="h-px flex-1 bg-background-300" />
            <span className="font-label text-xs text-foreground-500">深扒长图专栏</span>
          </div>

          <h2 className="mt-6 font-heading text-3xl font-bold leading-snug tracking-tight text-foreground-950 md:text-5xl md:leading-[1.18]">
            把一场内幕，
            <br />
            拆成一张能读完的长图
          </h2>

          <p className="mt-5 max-w-xl font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            黑料图文用长图与多图对比，把事件的前因后果、幕后关联与时间线逐层还原。从聊天记录到公开动态，
            每一处矛盾都标注在图上，让你一次看清全貌，而不是被零散的截图牵着走。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#featured"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-open-line text-base" />
              开始阅读本期深扒
            </a>
            <a
              href="#download"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-6 py-3 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-qr-code-line text-base" />
              扫码进入长图库
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {heroMeta.map((item) => (
              <div key={item.label} className="flex flex-col">
                <dt className="font-label text-xs text-foreground-500">{item.label}</dt>
                <dd className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        </Reveal>

        <Reveal className="flex" delay={120}>
          <div className="relative w-full">
            <div className="relative h-[360px] w-full overflow-hidden rounded-lg border border-background-200 bg-background-100 md:h-[520px] lg:h-full lg:min-h-[520px]">
              <img
                src={heroCover.image}
                alt="黑料图文深扒长图专栏封面"
                title="黑料图文深扒长图"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute left-4 top-4 flex items-center gap-2 rounded-md bg-background-50/90 px-3 py-1.5">
                <i className="ri-bookmark-3-line text-primary-600" />
                <span className="font-label text-xs text-foreground-800">{heroCover.badge}</span>
              </div>
            </div>
            <div className="absolute -bottom-4 -right-2 flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3 shadow-none md:-right-4">
              <span className="font-heading text-lg font-bold text-accent-600">{heroCover.issue}</span>
              <span className="h-8 w-px bg-background-300" />
              <span className="font-label text-xs leading-tight text-foreground-600">
                杂志式
                <br />
                {heroCover.cornerLabel}
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}